export interface nonPlayerCharactersState {
  nonPlayerCharacters: Array<nonPlayerCharacterInterface>;
}
export interface nonPlayerCharacterInterface {
  id: string;
  name: string;
  hp: number;
  mana: number;
  description: string;
  abilities: string;
}

export default {
  namespaced: true,
  state: (): nonPlayerCharactersState => ({
    nonPlayerCharacters: [],
  }),
  getters: {
    characters: (state: nonPlayerCharactersState) => {
      return state.nonPlayerCharacters;
    },
  },
  mutations: {
    setNonPlayerCharacters: (
      state: nonPlayerCharactersState,
      newData: Array<nonPlayerCharacterInterface>
    ) => {
      state.nonPlayerCharacters = newData;
    },
    addNonPLayerCharacterToAdventure: (
      state: nonPlayerCharactersState,
      newData: nonPlayerCharacterInterface
    ) => {
      state.nonPlayerCharacters.push(newData);
    },
  },
  removeNonPLayerCharacterFromAdventure: (
    state: nonPlayerCharactersState,
    newData: string
  ) => {
    for (let i = 0; i < state.nonPlayerCharacters.length; i++) {
      if (state.nonPlayerCharacters[i].id === newData) {
        state.nonPlayerCharacters.splice(i, 1);
      }
    }
  },
  editNonPLayerCharacterInAdventure: (
    state: nonPlayerCharactersState,
    newData: nonPlayerCharacterInterface
  ) => {
    for (let i = 0; i < state.nonPlayerCharacters.length; i++) {
      if (state.nonPlayerCharacters[i].id === newData.id) {
        state.nonPlayerCharacters.splice(i, 1, newData);
      }
    }
  },
};
